export default __webpack_public_path__ + "static/media/after_noon.14e9d22b.png";